<template>
  <div class="container">
    <h2>📄 Documentación API: Crear Factura</h2>
    <p>
      Documentación completa con ejemplos, catálogos y manejo de errores:
      <a :href="docsUrl" target="_blank" rel="noopener">{{ docsUrl }}</a>
    </p>

    <section>
      <h3>📌 Endpoint</h3>
      <p>
        <strong>URL:</strong> <code>{{ endpoint }}</code>
      </p>
      <p><strong>Método:</strong> POST</p>
      <ul>
        <li><code>Accept: application/json</code></li>
        <li><code>Content-Type: application/json</code></li>
        <li><code>Authorization: Bearer &lt;tu_token&gt;</code></li>
      </ul>
    </section>

    <section>
      <h3>📤 Ejemplo de Request</h3>
      <pre><code>{{ formattedJson }}</code></pre>
    </section>

    <section>
      <h3>📥 Ejemplo CURL</h3>
      <pre><code>{{ curlCommand }}</code></pre>
    </section>

    <section>
      <h3>📚 Catálogos de campos</h3>

      <h4>🧾 forma_pago</h4>
      <ul>
        <li v-for="(desc, code) in catalogos.forma_pago" :key="code">
          <code>{{ code }}</code
          >: {{ desc }}
        </li>
      </ul>

      <h4>🆔 id_comprador</h4>
      <ul>
        <li v-for="(desc, code) in catalogos.id_comprador" :key="code">
          <code>{{ code }}</code
          >: {{ desc }}
        </li>
      </ul>

      <h4>🌐 es_produccion</h4>
      <ul>
        <li><code>true</code>: Ambiente de producción</li>
        <li><code>false</code>: Ambiente de pruebas (desarrollo)</li>
      </ul>

      <h4>💰 codigo_impuesto</h4>
      <ul>
        <li v-for="(desc, code) in catalogos.codigo_impuesto" :key="code">
          <code>{{ code }}</code
          >: {{ desc }}
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
export default {
  name: "ApiInvoiceDoc",
  data() {
    return {
      endpoint: "https://crm.mydessk.com/api/v1/invoice",
      docsUrl: "https://crm.mydessk.com/developers",
      requestBody: {
        cliente: {
          es_produccion: false,
          forma_pago: "01",
          id_comprador: "05",
          nombre_comprador: "María Fernanda Torres",
          identificacion_comprador: "1712345675",
          correo: "compras@ejemplo.com",
          direccion_comprador: "Av. Amazonas N34-120, Quito",
          total_sin_impuestos: 1.0,
          total_descuento: 0.0,
          base_imponible: 1.0,
          valor_impuesto: 0.15,
          propina: 0.0,
          valor_total: 1.15,
          extras: [
            {
              nombre: "Información adicional",
              descripcion: "Detalle extra 1"
            },
            {
              nombre: "Otra info",
              descripcion: "Detalle extra 2"
            }
          ]
        },
        productos: [
          {
            codigo: "PROD001",
            nombre: "Producto con IVA 15%",
            cantidad: 1,
            precio_unitario: 1.0,
            sub_total: 1.0,
            iva_total: 0.15,
            codigo_impuesto: "6"
          }
        ]
      },
      catalogos: {
        forma_pago: {
          "01": "SIN UTILIZACION DEL SISTEMA FINANCIERO (Efectivo)",
          "16": "TARJETA DE DÉBITO",
          "17": "DINERO ELECTRÓNICO",
          "18": "TARJETA PREPAGO",
          "19": "TARJETA DE CRÉDITO",
          "20": "OTROS CON UTILIZACIÓN DEL SISTEMA FINANCIERO",
          "21": "ENDOSO DE TÍTULOS"
        },
        id_comprador: {
          "04": "RUC",
          "05": "CÉDULA",
          "06": "PASAPORTE",
          "07": "CONSUMIDOR FINAL",
          "08": "EXTERIOR",
          "09": "PLACA"
        },
        codigo_impuesto: {
          "1": "IVA 0%",
          "2": "IVA 12% (obsoleto, el SRI lo rechaza)",
          "6": "IVA 15%",
          "10": "IVA Diferenciado"
        }
      }
    };
  },
  computed: {
    formattedJson() {
      return JSON.stringify(this.requestBody, null, 2);
    },
    curlCommand() {
      return `
curl --location '${this.endpoint}' \\
--header 'Accept: application/json' \\
--header 'Content-Type: application/json' \\
--header 'Authorization: Bearer <tu_token>' \\
--data-raw '${JSON.stringify(this.requestBody, null, 2)}'
`.trim();
    }
  }
};
</script>

<style scoped>
.container {
  max-width: 960px;
  margin: auto;
  padding: 2rem;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}
h2,
h3,
h4 {
  color: #2c3e50;
  margin-top: 1.5rem;
}
ul {
  list-style-type: none;
  padding-left: 0;
}
code {
  background-color: #f8f8f8;
  padding: 2px 6px;
  border-radius: 4px;
}
pre {
  background-color: #f0f0f0;
  padding: 1rem;
  overflow-x: auto;
  border-radius: 6px;
  font-size: 14px;
}
</style>
